"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandshakeRpcLocal = void 0;
const dht_1 = require("@streamr/dht");
const utils_1 = require("@streamr/utils");
const logger = new utils_1.Logger(module);
class HandshakeRpcLocal {
    options;
    constructor(options) {
        this.options = options;
    }
    async handshake(request, context) {
        return this.handleRequest(request, context);
    }
    handleRequest(request, context) {
        const senderDescriptor = context.incomingSourceDescriptor;
        const getInterleaveNodeIds = () => (request.interleaveNodeId !== undefined) ? [(0, dht_1.toDhtAddress)(request.interleaveNodeId)] : [];
        const senderNodeId = (0, dht_1.toNodeId)(senderDescriptor);
        if (this.options.ongoingInterleaves.has(senderNodeId)) {
            return this.rejectHandshake(request);
        }
        else if (this.options.neighbors.has(senderNodeId)
            || this.options.ongoingHandshakes.has(senderNodeId)) {
            return this.acceptHandshake(request, senderDescriptor);
        }
        else if (this.options.neighbors.size() + this.options.ongoingHandshakes.size < this.options.maxNeighborCount) {
            return this.acceptHandshake(request, senderDescriptor);
        }
        else if (this.options.neighbors.size(getInterleaveNodeIds()) - this.options.ongoingInterleaves.size >= 2
            && this.options.neighbors.size() <= this.options.maxNeighborCount) {
            // Do not accept the handshakes requests if the target neighbor count can potentially drop below 2 
            // due to interleaving. This ensures that a stable number of connections is kept during high churn.
            return this.acceptHandshakeWithInterleaving(request, senderDescriptor);
        }
        else {
            return this.rejectHandshake(request);
        }
    }
    acceptHandshake(request, requester) {
        const res = {
            requestId: request.requestId,
            accepted: true
        };
        this.options.neighbors.add(this.options.createContentDeliveryRpcRemote(requester));
        return res;
    }
    // eslint-disable-next-line class-methods-use-this
    rejectHandshake(request) {
        const res = {
            requestId: request.requestId,
            accepted: false
        };
        return res;
    }
    acceptHandshakeWithInterleaving(request, requester) {
        const exclude = [];
        request.neighborNodeIds.forEach((id) => exclude.push((0, dht_1.toDhtAddress)(id)));
        this.options.ongoingInterleaves.forEach((id) => exclude.push(id));
        exclude.push((0, dht_1.toNodeId)(requester));
        if (request.interleaveNodeId !== undefined) {
            exclude.push((0, dht_1.toDhtAddress)(request.interleaveNodeId));
        }
        const last = this.options.neighbors.getLast(exclude);
        const lastPeerDescriptor = last ? last.getPeerDescriptor() : undefined;
        if (last) {
            const nodeId = (0, dht_1.toNodeId)(last.getPeerDescriptor());
            const remote = this.options.createRpcRemote(last.getPeerDescriptor());
            this.options.ongoingInterleaves.add(nodeId);
            // Run this with then catch instead of setImmediate to avoid changes in state
            // eslint-disable-next-line promise/catch-or-return
            remote.interleaveRequest(requester).then((response) => {
                // If response is accepted, remove the last node from the target neighbors
                // and unlock the connection
                // If response is not accepted, keep the last node as a neighbor
                if (response.accepted) {
                    this.options.neighbors.remove((0, dht_1.toNodeId)(lastPeerDescriptor));
                }
            }).catch(() => {
                // no-op: InterleaveRequest cannot reject
            }).finally(() => {
                this.options.ongoingInterleaves.delete(nodeId);
            });
        }
        this.options.neighbors.add(this.options.createContentDeliveryRpcRemote(requester));
        return {
            requestId: request.requestId,
            accepted: true,
            interleaveTargetDescriptor: lastPeerDescriptor
        };
    }
    async interleaveRequest(message, context) {
        const senderPeerDescriptor = context.incomingSourceDescriptor;
        const remoteNodeId = (0, dht_1.toNodeId)(senderPeerDescriptor);
        try {
            await this.options.handshakeWithInterleaving(message.interleaveTargetDescriptor, remoteNodeId);
            this.options.neighbors.remove(remoteNodeId);
            return { accepted: true };
        }
        catch (err) {
            logger.debug(`interleaveRequest to ${(0, dht_1.toNodeId)(message.interleaveTargetDescriptor)} failed`, { err });
            return { accepted: false };
        }
    }
}
exports.HandshakeRpcLocal = HandshakeRpcLocal;
//# sourceMappingURL=HandshakeRpcLocal.js.map